// Mock data para propiedades inmobiliarias
export const mockProperties = [
  {
    id: "1",
    titulo: "Casa Residencial Premium en Zona Norte",
    descripcion: "Hermosa casa residencial en una de las zonas más exclusivas de la ciudad. Acabados de lujo, amplios espacios y excelente ubicación cerca de escuelas, centros comerciales y hospitales.",
    precio: 4500000,
    tipo: "venta", // venta o renta
    estatus: "disponible", // disponible, vendida, rentada
    
    // Ubicación
    direccion: "Av. Las Palmas 1234",
    colonia: "Residencial Los Pinos",
    ciudad: "Monterrey",
    estado: "Nuevo León",
    codigoPostal: "64000",
    
    // Características principales
    areaTotal: 350,
    areaConstruida: 280,
    habitaciones: 4,
    banosCompletos: 3,
    mediosBanos: 1,
    estacionamientos: 2,
    niveles: 2,
    
    // Detalles adicionales
    anioConstruccion: 2020,
    antiguedad: 4,
    tipoPropiedad: "Casa", // Casa, Departamento, Terreno, Local Comercial, Oficina
    
    // Amenidades y características
    amenidades: ["Alberca", "Jardín", "Terraza", "Área de juegos", "Cuarto de servicio", "Closets empotrados"],
    caracteristicasEspeciales: ["Cocina integral de lujo", "Pisos de mármol", "Sistema de seguridad", "Paneles solares", "Cisterna"],
    
    // Servicios
    servicios: {
      agua: true,
      luz: true,
      gas: true,
      internet: true,
      drenaje: true,
      cableTV: true
    },
    
    // Legal
    escrituracion: "Al corriente",
    regimenPropiedad: "Propiedad privada",
    
    // Multimedia
    fotos: [
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800",
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800",
      "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800",
      "https://images.unsplash.com/photo-1600573472550-8090b5e0745e?w=800",
      "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800"
    ],
    videos: [
      "https://www.youtube.com/embed/dQw4w9WgXcQ"
    ],
    
    // Contacto
    agenteNombre: "FD-Inmobiliaria",
    agenteTelefono: "+52 984 1387001",
    agenteEmail: "contacto@fdservicios.com",
    agenteWhatsApp: "+5215219841387001",
    
    fechaPublicacion: "2024-01-15"
  },
  {
    id: "2",
    titulo: "Departamento Moderno en el Centro",
    descripcion: "Departamento completamente remodelado en el corazón de la ciudad. Perfecto para profesionistas o pareja joven. Excelente conectividad con transporte público y a minutos de las principales avenidas.",
    precio: 15000,
    tipo: "renta",
    estatus: "disponible",
    
    direccion: "Calle Hidalgo 567, Piso 8",
    colonia: "Centro Histórico",
    ciudad: "Monterrey",
    estado: "Nuevo León",
    codigoPostal: "64000",
    
    areaTotal: 85,
    areaConstruida: 85,
    habitaciones: 2,
    banosCompletos: 1,
    mediosBanos: 0,
    estacionamientos: 1,
    niveles: 1,
    
    anioConstruccion: 2018,
    antiguedad: 6,
    tipoPropiedad: "Departamento",
    
    amenidades: ["Gimnasio", "Roof garden", "Elevador", "Seguridad 24/7", "Área de lavandería"],
    caracteristicasEspeciales: ["Piso laminado", "Cocina equipada", "Aire acondicionado", "Balcón", "Amueblado"],
    
    servicios: {
      agua: true,
      luz: true,
      gas: true,
      internet: true,
      drenaje: true,
      cableTV: false
    },
    
    escrituracion: "Al corriente",
    regimenPropiedad: "Condominio",
    
    fotos: [
      "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800",
      "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800",
      "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800",
      "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=800",
      "https://images.unsplash.com/photo-1484154218962-a197022b5858?w=800"
    ],
    videos: [],
    
    agenteNombre: "FD-Inmobiliaria",
    agenteTelefono: "+52 984 1387001",
    agenteEmail: "contacto@fdservicios.com",
    agenteWhatsApp: "+5215219841387001",
    
    fechaPublicacion: "2024-02-01"
  },
  {
    id: "3",
    titulo: "Terreno Residencial con Excelente Ubicación",
    descripcion: "Terreno plano ideal para construir la casa de tus sueños. Ubicado en zona residencial tranquila y segura. Todos los servicios disponibles en la zona. Documentación en regla.",
    precio: 1800000,
    tipo: "venta",
    estatus: "disponible",
    
    direccion: "Privada San Miguel Lote 15",
    colonia: "Valle Alto",
    ciudad: "Monterrey",
    estado: "Nuevo León",
    codigoPostal: "64989",
    
    areaTotal: 400,
    areaConstruida: 0,
    habitaciones: 0,
    banosCompletos: 0,
    mediosBanos: 0,
    estacionamientos: 0,
    niveles: 0,
    
    anioConstruccion: null,
    antiguedad: 0,
    tipoPropiedad: "Terreno",
    
    amenidades: ["Acceso controlado", "Calles pavimentadas", "Alumbrado público", "Áreas verdes"],
    caracteristicasEspeciales: ["Terreno plano", "Esquina", "Forma regular", "Uso de suelo habitacional"],
    
    servicios: {
      agua: true,
      luz: true,
      gas: true,
      internet: true,
      drenaje: true,
      cableTV: false
    },
    
    escrituracion: "Escrituras listas",
    regimenPropiedad: "Propiedad privada",
    
    fotos: [
      "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=800",
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800",
      "https://images.unsplash.com/photo-1464146072230-91cabc968266?w=800"
    ],
    videos: [],
    
    agenteNombre: "FD-Inmobiliaria",
    agenteTelefono: "+52 984 1387001",
    agenteEmail: "contacto@fdservicios.com",
    agenteWhatsApp: "+5215219841387001",
    
    fechaPublicacion: "2024-01-20"
  },
  {
    id: "4",
    titulo: "Local Comercial en Plaza Comercial",
    descripcion: "Excelente local comercial en plaza de alta afluencia. Ideal para cualquier tipo de negocio. Amplio estacionamiento, excelente visibilidad y ubicación estratégica sobre avenida principal.",
    precio: 25000,
    tipo: "renta",
    estatus: "disponible",
    
    direccion: "Plaza San Pedro Local 12",
    colonia: "San Pedro Garza García",
    ciudad: "San Pedro Garza García",
    estado: "Nuevo León",
    codigoPostal: "66260",
    
    areaTotal: 120,
    areaConstruida: 120,
    habitaciones: 0,
    banosCompletos: 2,
    mediosBanos: 0,
    estacionamientos: 3,
    niveles: 1,
    
    anioConstruccion: 2019,
    antiguedad: 5,
    tipoPropiedad: "Local Comercial",
    
    amenidades: ["Estacionamiento amplio", "Seguridad 24/7", "Área de carga", "Elevador de carga"],
    caracteristicasEspeciales: ["Escaparate grande", "Bodega incluida", "Preparación para restaurante", "Clima central"],
    
    servicios: {
      agua: true,
      luz: true,
      gas: true,
      internet: true,
      drenaje: true,
      cableTV: false
    },
    
    escrituracion: "Contrato comercial",
    regimenPropiedad: "Arrendamiento comercial",
    
    fotos: [
      "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800",
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=800",
      "https://images.unsplash.com/photo-1497215728101-856f4ea42174?w=800",
      "https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=800"
    ],
    videos: [],
    
    agenteNombre: "FD-Inmobiliaria",
    agenteTelefono: "+52 984 1387001",
    agenteEmail: "contacto@fdservicios.com",
    agenteWhatsApp: "+5215219841387001",
    
    fechaPublicacion: "2024-02-05"
  },
  {
    id: "5",
    titulo: "Casa de Lujo con Alberca y Jardín Amplio",
    descripcion: "Espectacular residencia de lujo en privada exclusiva. Casa diseñada por reconocido arquitecto con los mejores acabados y tecnología de vanguardia. Alberca climatizada, jardín de 200m², home theater y más.",
    precio: 8900000,
    tipo: "venta",
    estatus: "disponible",
    
    direccion: "Privada Los Encinos 789",
    colonia: "Carretera Nacional",
    ciudad: "Monterrey",
    estado: "Nuevo León",
    codigoPostal: "64930",
    
    areaTotal: 650,
    areaConstruida: 480,
    habitaciones: 5,
    banosCompletos: 4,
    mediosBanos: 2,
    estacionamientos: 4,
    niveles: 2,
    
    anioConstruccion: 2021,
    antiguedad: 3,
    tipoPropiedad: "Casa",
    
    amenidades: ["Alberca climatizada", "Jardín amplio", "Terraza techada", "BBQ área", "Cuarto de juegos", "Home theater", "Gimnasio", "Cava de vinos", "Cocina exterior"],
    caracteristicasEspeciales: ["Domótica completa", "Pisos de mármol italiano", "Cocina de diseñador", "Ventanas automatizadas", "Sistema de sonido Bose", "Iluminación LED inteligente", "Paneles solares Tesla"],
    
    servicios: {
      agua: true,
      luz: true,
      gas: true,
      internet: true,
      drenaje: true,
      cableTV: true
    },
    
    escrituracion: "Escrituras al corriente",
    regimenPropiedad: "Propiedad privada en condominio",
    
    fotos: [
      "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800",
      "https://images.unsplash.com/photo-1613977257363-707ba9348227?w=800",
      "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800",
      "https://images.unsplash.com/photo-1615529162924-f0b2f34b3e4b?w=800",
      "https://images.unsplash.com/photo-1600607687644-c7171b42498b?w=800",
      "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800",
      "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800"
    ],
    videos: [
      "https://www.youtube.com/embed/dQw4w9WgXcQ"
    ],
    
    agenteNombre: "FD-Inmobiliaria",
    agenteTelefono: "+52 984 1387001",
    agenteEmail: "contacto@fdservicios.com",
    agenteWhatsApp: "+5215219841387001",
    
    fechaPublicacion: "2024-01-10"
  },
  {
    id: "6",
    titulo: "Departamento Amueblado en Renta Temporal",
    descripcion: "Hermoso departamento completamente amueblado y equipado, ideal para estancias temporales o profesionistas. Ubicación privilegiada cerca de hospitales y universidades. Listo para habitar.",
    precio: 18500,
    tipo: "renta",
    estatus: "disponible",
    
    direccion: "Torres del Bosque Torre A-1502",
    colonia: "Del Valle",
    ciudad: "San Pedro Garza García",
    estado: "Nuevo León",
    codigoPostal: "66220",
    
    areaTotal: 110,
    areaConstruida: 110,
    habitaciones: 2,
    banosCompletos: 2,
    mediosBanos: 0,
    estacionamientos: 2,
    niveles: 1,
    
    anioConstruccion: 2020,
    antiguedad: 4,
    tipoPropiedad: "Departamento",
    
    amenidades: ["Alberca", "Gimnasio", "Salón de eventos", "Área infantil", "Pet friendly", "Roof garden", "Seguridad 24/7", "Elevadores"],
    caracteristicasEspeciales: ["Totalmente amueblado", "Electrodomésticos incluidos", "Ropa de cama", "Vajilla completa", "Smart TV", "Internet fibra óptica incluido"],
    
    servicios: {
      agua: true,
      luz: true,
      gas: true,
      internet: true,
      drenaje: true,
      cableTV: true
    },
    
    escrituracion: "Contrato de arrendamiento",
    regimenPropiedad: "Condominio vertical",
    
    fotos: [
      "https://images.unsplash.com/photo-1493809842364-78817add7ffb?w=800",
      "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800",
      "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800",
      "https://images.unsplash.com/photo-1512918728675-ed5a9ecdebfd?w=800",
      "https://images.unsplash.com/photo-1560185007-c5ca9d2c014d?w=800"
    ],
    videos: [],
    
    agenteNombre: "FD-Inmobiliaria",
    agenteTelefono: "+52 984 1387001",
    agenteEmail: "contacto@fdservicios.com",
    agenteWhatsApp: "+5215219841387001",
    
    fechaPublicacion: "2024-02-10"
  }
];

// Función helper para filtrar propiedades
export const filterProperties = (properties, filters) => {
  return properties.filter(property => {
    // Filtro por tipo (venta/renta)
    if (filters.tipo && property.tipo !== filters.tipo) {
      return false;
    }
    
    // Filtro por tipo de propiedad
    if (filters.tipoPropiedad && property.tipoPropiedad !== filters.tipoPropiedad) {
      return false;
    }
    
    // Filtro por rango de precio
    if (filters.precioMin && property.precio < filters.precioMin) {
      return false;
    }
    if (filters.precioMax && property.precio > filters.precioMax) {
      return false;
    }
    
    // Filtro por habitaciones
    if (filters.habitacionesMin && property.habitaciones < parseInt(filters.habitacionesMin)) {
      return false;
    }
    
    // Filtro por ciudad
    if (filters.ciudad && property.ciudad.toLowerCase() !== filters.ciudad.toLowerCase()) {
      return false;
    }
    
    return true;
  });
};

// Datos del agente para la página "Acerca de mí"
export const agenteInfo = {
  nombre: "Franco Dimuro",
  empresa: "FD-Inmobiliaria",
  titulo: "Agente Inmobiliario Certificado CONOCER",
  descripcion: "Con 5 años de experiencia en el mercado inmobiliario de Quintana Roo y 23 años en servicios al cliente, me especializo en la venta y renta de propiedades residenciales, comerciales y terrenos. Mi amplia trayectoria en atención personalizada me ha permitido desarrollar habilidades excepcionales para entender y satisfacer las necesidades de mis clientes. He colaborado con más de 500 agentes inmobiliarios, construyendo una sólida red profesional. Cuento con certificación oficial CONOCER en Asesoría en comercialización de bienes inmuebles (EC0110.02). Mi compromiso es brindarte un servicio profesional, honesto y personalizado para encontrar la propiedad de tus sueños o vender la tuya al mejor precio.",
  telefono: "+52 984 1387001",
  email: "ejecutivo@fd-inmobiliaria.homes",
  whatsapp: "+5215219841387001",
  direccionOficina: "Playa del Carmen, Quintana Roo",
  horarioAtencion: "Lunes a Viernes: 9:00 AM - 7:00 PM | Sábados: 10:00 AM - 2:00 PM",
  certificaciones: [
    "Certificación CONOCER (Consejo Nacional de Normalización y Certificación de Competencias Laborales)",
    "Estándar de Competencia EC0110.02 - Asesoría en comercialización de bienes inmuebles",
    "23 años de experiencia en Servicios al Cliente",
    "Asociación Mexicana de Profesionales Inmobiliarios (AMPI)",
    "Red de colaboración con más de 500 agentes inmobiliarios",
    "Especialización en Valuación de Inmuebles"
  ],
  servicios: [
    "Compra y Venta de Propiedades",
    "Arrendamiento y Administración",
    "Atención Personalizada al Cliente (23 años de experiencia)",
    "Avalúos Profesionales",
    "Asesoría Legal Inmobiliaria",
    "Inversión en Bienes Raíces",
    "Marketing Digital de Propiedades",
    "Red de Colaboración con +500 Agentes"
  ],
  foto: "https://customer-assets.emergentagent.com/job_property-media/artifacts/2pad6wkx_Screenshot_20260409-114033_Gallery.jpg"
};
